import { ILoginSession } from 'types/session';
import { Reducer as LoginReducer } from 'modules/login';

import { END_OF_OPERATION, ERROR, PLATFORM_SELECTION, SUCCESS } from '../../states/states.constants';
import { LOGIN_TYPE, SET_LOGIN_FETCHING } from 'modules/login/login.constants';
import { SWITCH_PREVIEW_STATE_HOST, SwitchPreviewStateAction } from '@sitegen/common/types/root-actions';
import { Actions } from 'modules/login/login.actions';

const loggedState: ILoginSession = {
    type: LOGIN_TYPE.NEW_LOGIN,
    sessionId: '740ab387-b4a5-45fd-bfae-bd61b8dbccdc',
    isUbisoftConnectAuthenticated: true,
    UbisoftConnectProfile: {
        op: 'getProfiles',
        status: 'OK',
        ref: '12f7f27b-e4ef-4a29-9fe3-a9712d0db247_530',
        user: {
            profileId: '9d7dab4d-0403-4838-9aed-10b9b77591b5',
            userId: '9d7dab4d-0403-4838-9aed-10b9b77591b5',
            platformType: 'uplay',
            idOnPlatform: '9D7DAB4D-0403-4838-9AED-10B9B77591B5',
            nameOnPlatform: 'ulgui-ubi4'
        }
    },
    UbisoftConnectProfiles: [
        {
            id: 'PC',
            profileId: '9d7dab4d-0403-4838-9aed-10b9b77591b5',
            userId: '9d7dab4d-0403-4838-9aed-10b9b77591b5',
            idOnPlatform: '9D7DAB4D-0403-4838-9AED-10B9B77591B5',
            nameOnPlatform: 'uplayKnight'
        },
        {
            id: 'PS4',
            profileId: '2b204df2-75e3-400b-bbd4-0ba28c8eae77',
            userId: '9d7dab4d-0403-4838-9aed-10b9b77591b5',
            idOnPlatform: '6808430300154271139',
            nameOnPlatform: 'PSUser'
        },
        {
            id: 'XONE'
        },
        {
            id: 'SWITCH'
        }
    ],
    UbisoftConnectTicket: 'ew0KICAidmVyIjogIjEiLA0KICAiYWlkIjogIjEyZjdmMjdiLWU0ZWYtNGEyOS05ZmUzLWE5NzEyZDBkYjI0NyIsDQogICJlbnYiOiAiVUFUI'
};

export const loginSession = (state = LoginReducer.initialState, action: Actions | SwitchPreviewStateAction): LoginReducer.IState => {
    switch (action.type) {
    case SWITCH_PREVIEW_STATE_HOST: {
        switch (action.payload) {
        case END_OF_OPERATION:
        case PLATFORM_SELECTION:
        case SUCCESS:
        case ERROR:
            return {
                fetching: false,
                loginSession: loggedState,
                hasTPCEnabled: true,
                hasOverlayLoaded: false
            };
        default:
            return state;
        }
    }
    case SET_LOGIN_FETCHING: {
        return {
            fetching: action.payload,
            loginSession: undefined,
            hasTPCEnabled: false,
            hasOverlayLoaded: false
        };
    }
    default:
        return state;
    }
};

export default loginSession;
